import React from 'react'
import BranchImg1 from '../../Images/BranchesImg/Branch1.png'
import BranchImg2 from '../../Images/BranchesImg/Branch2.png'
import BranchImg3 from '../../Images/BranchesImg/Branch3.png'
import '../../css/branchespage.css'
import Aos from 'aos'

const BranchesPage = () => {

    Aos.init({
        duration: 1500,
        once: false,
        mirror: false,
        easing: 'ease-in-out-sine'
    })

    const BranchesList = [
        {
            branchID: '1',
            branchName: 'सुन्दरपुर सेवाकेन्द्र',
            bImage: BranchImg1,
            path: '/branches/sunderpur-service-center'
        },
        {
            branchID: '2',
            branchName: 'दुलारी सेवाकेन्द्र',
            bImage: BranchImg2,
            path: '/branches/dulari-service-center'
        },
        {
            branchID: '3',
            branchName: 'विराटचोक सेवाकेन्द्र',
            bImage: BranchImg3,
            path: '/branches/biratchowk-service-center'
        },
    ]

    return (
        <>
            <div className='branches-div'>
                <div className='branches-top' data-aos='fade-right'>
                    <div className='welcome-title-center'>
                        <h2><span>हाम्रा सेवाकेन्द्रहरु</span></h2>
                    </div>
                </div>
                <div className='branches-body'>
                    <div className='card-container'>
                        {BranchesList.map((item, id) => {
                            return (
                                <a href={item.path} onClick={() => window.scrollTo({ top: 0 })} key={id}>
                                    <div className='card' style={{ width: '300px' }} data-aos='fade-right'>
                                        <div className='inner'>
                                            <div className='img-holder'>
                                                <img src={item.bImage} alt='Branch-Image' />
                                            </div>
                                            <div className='detail'>
                                                <h3>{item.branchName}</h3>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            )
                        })}
                    </div>
                </div>
            </div>
        </>
    )
}

export default BranchesPage